function _template() {return `<div class="privacy-warning">
    <span class="privacy-content"></span>
    <button class="hide-button">
        <i class="spsc-icon-close"></i>
    </button>
</div>`;}export default function (ctx) {return _template.call(ctx, ctx);};